import React from 'react';

export const ListViewIcon = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3.33822C3.63181 3.33822 3.33333 3.63669 3.33333 4.00488V12.0049C3.33333 12.3731 3.63181 12.6715 4 12.6715H12C12.3682 12.6715 12.6667 12.3731 12.6667 12.0049V4.00488C12.6667 3.63669 12.3682 3.33822 12 3.33822H4ZM2 4.00488C2 2.90031 2.89543 2.00488 4 2.00488H12C13.1046 2.00488 14 2.90031 14 4.00488V12.0049C14 13.1095 13.1046 14.0049 12 14.0049H4C2.89543 14.0049 2 13.1095 2 12.0049V4.00488Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2.00488C6.36819 2.00488 6.66667 2.30336 6.66667 2.67155V13.3382C6.66667 13.7064 6.36819 14.0049 6 14.0049C5.63181 14.0049 5.33333 13.7064 5.33333 13.3382V2.67155C5.33333 2.30336 5.63181 2.00488 6 2.00488Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 5.99989C14 6.36808 13.7015 6.66656 13.3333 6.66656L2.66667 6.66656C2.29848 6.66656 2 6.36808 2 5.99989C2 5.6317 2.29848 5.33322 2.66667 5.33322L13.3333 5.33323C13.7015 5.33323 14 5.6317 14 5.99989Z"
      fill="currentColor"
    />
  </svg>
);
